import { configureStore } from "@reduxjs/toolkit";
import appSlice from "./slices/appSlice";
import authSlice from "./slices/authSlice";
import subCategorySlice from "./slices/subCategorySlice";
import castSlice from "./slices/castSlice";
import userSlice from "./slices/userSlice";
import adSlice from "./slices/adSlice";
import musicSlice from "./slices/musicSlice";
import songSlice from "./slices/songSlice";
import notificationSlice from "./slices/notificationSlice";
import reviewSlice from "./slices/reviewsSlice";
import adminSlice from "./slices/adminSlice";


const store = configureStore({
    reducer: {
        app : appSlice ,
        auth : authSlice ,
        subCategory : subCategorySlice ,
        cast : castSlice ,
        user : userSlice ,
        ad : adSlice ,
        music : musicSlice ,
        song : songSlice ,
        notification : notificationSlice ,
        review: reviewSlice,
        admin: adminSlice
    }
});

export default store;